<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2s"><a id="page_xix"></a><a id="gloss"></a>GLOSSARY</h2>
<h3 class="h3g"><em>Abbreviations</em></h3>
<p class="glossary">G: West African/Gullah</p>
<p class="glossary">CE: Gullah-influenced Charleston English</p>
<p class="glossaryt">Adu: Yoruba/G, very black</p>
<p class="glossary">Ajani: Yoruba/G, one who wins after a struggle</p>
<p class="glossary">Andunu: Wolof, we are not united. G, I was not with you</p>
<p class="glossary">Bay-uh: CE, beer and bear; pronounced the same</p>
<p class="glossary">Becuz: G/CE, because</p>
<p class="glossary">Bin yah: G/CE, been here</p>
<p class="glossary">Bo-it: G/CE, boat</p>
<p class="glossary">Buckruh: Ibibio/Efik/G, white man. High buckruh: rich white man</p>
<p class="glossary">Dah: G/CE, nursemaid/nanny or servant. Ewe, mother, elder sister</p>
<p class="glossary">Dayclean: G, the sun has risen/broad daylight; pronounced <em>dey klin</em></p>
<p class="glossary">De mores: G, the most</p>
<p class="glossary">E/e: G, pronoun for he, she, or it</p>
<p class="glossary">Ebuh: G, ever. Evuh: CE, ever</p>
<p class="glossary">E luke’luke bird: G, a grayish-brown marsh bird</p>
<p class="glossary">E time fuh gone: G, it’s time to go</p>
<p class="glossary">E eye tie up on yuh: G, he/she can’t keep his/her eye off of you</p>
<p class="glossary">Enu fole: Ewe/G, to be pregnant</p>
<p class="glossary">Faw-ibe: G, five. Faw-ive: CE, five</p>
<p class="glossary">Fuh true: G/CE, truthfully</p>
<p class="glossary">Fus’ daa’k: G, first dark, twilight; or may say “sun lean”</p>
<p class="glossary">Gafa: G, evil spirit. Mende, spirit soul, idol</p>
<p class="glossary">Gho-iss: G/CE, ghost</p>
<p class="glossary">Gwi (or gwine): G, going, or would; also, future tense for “will”; “gone” may be used for all tenses of “go”</p>
<p class="glossary">Haint: G, a ghost or restless sprit that will sit on a person’s chest at night, and take the breath away, leaving him exhausted and weak in the morning. Also known as a Boo Hag or a Haint Hag.</p>
<p class="glossary">Harr-y-kin: CE, hurricane</p>
<p class="glossary"><a id="page_xx"></a>Head tek way: G, lost his/her mind, or he/she is crazy</p>
<p class="glossary">He’lenga: Mende/G, the period just after dark, the sitting-together time</p>
<p class="glossary">Hol’ um cheap: G, having no respect for someone</p>
<p class="glossary">Kamba’boli bird: G, a speckled bird who sings when the tide is rising.</p>
<p class="glossary">Kofi: Twi/Ewe/Fante/Gold Coast/G, basket name for boy born on a Friday</p>
<p class="glossary">Ma’magole: Mende/G, elderly white woman</p>
<p class="glossary">Marriage’um: G, to mix or blend</p>
<p class="glossary">Mek so?: G, why?</p>
<p class="glossary">Mek so yuh duh worry?: G, why are you so worried?</p>
<p class="glossary">Mores: G, most. De mores: G, the most</p>
<p class="glossary">Noko’noko: G, I’ll have nothing to do with you. Gold Coast, nothing, nothing</p>
<p class="glossary">Oonuh: G, you. Yuh: CE, your, or another form of “you”</p>
<p class="glossary">Olowo: Yoruba/G, a person who commands respect</p>
<p class="glossary">Pawpus: CE, porpoise</p>
<p class="glossary">Pizen: CE, poison</p>
<p class="glossary">Puntop: G/CE, up on top, or on top of</p>
<p class="glossary">Sibi bean: G, lima bean. Sivy: G/CE, lima bean. Seb: Wolof, bean</p>
<p class="glossary">Study e head: G, think hard about something</p>
<p class="glossary">Sun-Lean: G, sun begins to decline</p>
<p class="glossary">Sun-lean-fuh-down: G, sun is setting</p>
<p class="glossary">Sweetmouth: G, flattery, bribery</p>
<p class="glossary">Tana: Yoruba/G, to light a lamp. Bobangi/G, to be beautiful</p>
<p class="glossary">Tangledy: G, tangled; confusing</p>
<p class="glossary">Tata: Kimbundu/Kongo/G, father</p>
<p class="glossary">Tek foot een han’: G, to hurry; take his/her/your foot in his/her/your hand</p>
<p class="glossary">T’engk: G/CE, thank</p>
<p class="glossary">T’ink: G/CE, think</p>
<p class="glossary">Trute: G/CE, truth</p>
<p class="glossary">True-mouth: G, one who will not lie. Sometimes pronounced Trute-mout’</p>
<p class="glossary">Trus-me-Gawd: G, an undependable homemade boat</p>
<p class="glossary">Tummetuh: G/CE, tomato</p>
<p class="glossary">Wa’yiba: Kimbundu/G, bad person</p>
<p class="glossary">Wuk: G/CE, work</p>
<p class="glossary">Wulula: Kongo/G, to rescue from great danger to life</p>
<p class="glossaryt"><em>Sources</em></p>
<p class="glossary">Emory S. Campbell. <em>Gullah Cultural Legacies: A Synopsis of Gullah Traditions, Customary Beliefs, Art Forms and Speech on Hilton Head Island and Vicinal Sea <a id="page_xxi"></a><a id="page_xxii"></a>Islands in South Carolina and Georgia Gullah Cultural Legacies</em>. 3rd edition. Hilton Head, S.C.: Gullah Heritage Consulting Services, 2008.</p>
<p class="glossary">Virginia Mixson Geraty. <em>Gulluh Fuh Oonuh (Gullah for You): A Guide to the Gullah Language</em>. Orangeburg, S.C.: Sandlapper Publishing, 1998.</p>
<p class="glossary">Ambrose Elliot Gonzales. <em>The Black Border: Gullah Stories of the Carolina Coast</em>. Columbia, S.C.: State Company, 1922.</p>
<p class="glossary">Katherine Wyly Mille. “Charleston English.” In <em>The New Encyclopedia of Southern Culture</em>, vol. 5: <em>Language</em>, edited by Michael Montgomery, Ellen Johnson, and Charles Reagan Wilson. Chapel Hill: University of North Carolina Press, 2007.</p>
<p class="glossary">Lorenzo Dow Turner. <em>Africanisms in the Gullah Dialect</em>, with an introduction by Katherine Wyly Mille and Michael B. Montgomery. Columbia: University of South Carolina Press, 2002.</p>
<p class="glossary">Michael W. Twitty “Quotes Part Two: New Gems.” Afroculinaria. 20 Oct. 2011. Web. Accessed 27 Jan. 2015. <span class="weblink"><a href="http://afroculinaria.com/2011/10/20/quotes-part-two-new-gems/" target="_blank">http://afroculinaria.com/2011/10/20/quotes-part-two-new-gems/</a></span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// glossary.vue?51f84690